export default "__VITE_PUBLIC_ASSET__87d8aa7d__"